<div #container class="overflow-actions">
    <div class="inline-row">
        @for (item of visibleItems(); track item.id) {
            <div class="inline-item">
                <ng-container
                    [ngTemplateOutlet]="resolvedInlineItemTemplate()"
                    [ngTemplateOutletContext]="
                        getInlineItemContext(item, $index)
                    "
                />
            </div>
        }

        @if (hasOverflow()) {
            <mat-menu
                #menu="matMenu"
                [xPosition]="menuXPosition()"
                [attr.aria-label]="menuAriaLabel()"
            >
                @for (
                    item of overflowItems();
                    track item.id
                ) {
                    <ng-container
                        [ngTemplateOutlet]="resolvedMenuItemTemplate()"
                        [ngTemplateOutletContext]="
                            getMenuItemContext(
                                item,
                                visibleItems().length + $index
                            )
                        "
                    />
                }
            </mat-menu>

            @if (triggerVariant() === 'outlined') {
                <button
                    #trigger="matMenuTrigger"
                    qpxButton
                    matButton="outlined"
                    size="sm"
                    class="icon-only flex-0"
                    [matMenuTriggerFor]="menu"
                    [attr.aria-label]="triggerAriaLabel()"
                >
                    <ng-container
                        [ngTemplateOutlet]="resolvedTriggerTemplate()"
                        [ngTemplateOutletContext]="getTriggerContext()"
                    />
                </button>
            } @else {
                <button
                    #trigger="matMenuTrigger"
                    qpxButton
                    matIconButton
                    size="sm"
                    class="flex-0"
                    [matMenuTriggerFor]="menu"
                    [attr.aria-label]="triggerAriaLabel()"
                >
                    <ng-container
                        [ngTemplateOutlet]="resolvedTriggerTemplate()"
                        [ngTemplateOutletContext]="getTriggerContext()"
                    />
                </button>
            }
        }
    </div>

    <div class="measurement" aria-hidden="true">
        <div #measurementRow class="measurement-row">
            @for (item of items(); track item.id) {
                <div
                    class="measurement-item"
                    [attr.data-measure-item-id]="item.id"
                >
                    <ng-container
                        [ngTemplateOutlet]="resolvedInlineItemTemplate()"
                        [ngTemplateOutletContext]="
                            getInlineItemContext(item, $index)
                        "
                    />
                </div>
            }

            @if (triggerVariant() === 'outlined') {
                <button
                    qpxButton
                    matButton="outlined"
                    size="sm"
                    class="icon-only flex-0"
                    data-measure-trigger
                    tabindex="-1"
                >
                    <ng-container
                        [ngTemplateOutlet]="resolvedTriggerTemplate()"
                        [ngTemplateOutletContext]="{
                            hasOverflow: true,
                            overflowCount: items().length,
                        }"
                    />
                </button>
            } @else {
                <button
                    qpxButton
                    matIconButton
                    size="sm"
                    class="flex-0"
                    data-measure-trigger
                    tabindex="-1"
                >
                    <ng-container
                        [ngTemplateOutlet]="resolvedTriggerTemplate()"
                        [ngTemplateOutletContext]="{
                            hasOverflow: true,
                            overflowCount: items().length,
                        }"
                    />
                </button>
            }
        </div>
    </div>
</div>

<ng-template #defaultInlineItemTemplate let-item="item" let-trigger="trigger">
    @if (item.href) {
        <a
            qpxButton
            size="sm"
            matButton="outlined"
            [attr.aria-label]="item.ariaLabel || item.label"
            [routerLink]="item.href"
        >
            @if (item.icon) {
                <ng-icon qpx size="sm" [name]="item.icon" matButtonIcon />
            }

            <span>{{ item.label }}</span>
        </a>
    } @else {
        <button
            qpxButton
            size="sm"
            matButton="outlined"
            [disabled]="item.disabled ?? false"
            [attr.aria-label]="item.ariaLabel || item.label"
            (click)="trigger()"
        >
            @if (item.icon) {
                <ng-icon qpx size="sm" [name]="item.icon" matButtonIcon />
            }

            <span>{{ item.label }}</span>
        </button>
    }
</ng-template>

<ng-template #defaultMenuItemTemplate let-item="item" let-trigger="trigger">
    @if (item.href) {
        <a
            mat-menu-item
            [attr.aria-label]="item.ariaLabel || item.menuLabel || item.label"
            [routerLink]="item.href"
        >
            @if (item.icon) {
                <ng-icon qpx size="sm" [name]="item.icon" matMenuItemIcon />
            }

            <span>{{ item.menuLabel || item.label }}</span>
        </a>
    } @else {
        <button
            mat-menu-item
            type="button"
            [disabled]="item.disabled ?? false"
            [attr.aria-label]="item.ariaLabel || item.menuLabel || item.label"
            (click)="trigger()"
        >
            @if (item.icon) {
                <ng-icon qpx size="sm" [name]="item.icon" matMenuItemIcon />
            }

            <span>{{ item.menuLabel || item.label }}</span>
        </button>
    }
</ng-template>

<ng-template #defaultTriggerTemplate>
    <ng-icon qpx size="sm" name="lucideEllipsisVertical" matButtonIcon />
</ng-template>
